<main class="w-full h-full bg-new-nav">
  <mat-progress-bar class="absolute" *ngIf="isInitialLoading$ | async"></mat-progress-bar>

  <ng-container *ngIf="!(isLoggedIn$ | async); else loggedInTpl">
    <router-outlet></router-outlet>
  </ng-container>

  <ng-template #loggedInTpl>
    @let sidenav = sidenavContent();

    <mat-sidenav-container
      [hasBackdrop]="false"
      [class.justify-start]="!sidenav?.placement || sidenav?.placement === 'top'"
      [class.justify-center]="sidenav?.placement === 'middle'"
      [class.justify-end]="sidenav?.placement === 'bottom'"
      class="flex flex-col w-full h-full overflow-hidden sidenav-container bg-new-nav"
    >
      <mat-sidenav-content class="left-sidenav">
        <router-outlet name="modal"></router-outlet>
        <app-header></app-header>
        <app-new-sidenav></app-new-sidenav>
        <div class="overflow-hidden h-full flex flex-col w-full">
          <router-outlet></router-outlet>
        </div>
      </mat-sidenav-content>
      <mat-sidenav
        class="flex flex-col"
        [class.justify-start]="!sidenav?.placement || sidenav?.placement === 'top'"
        [class.justify-center]="sidenav?.placement === 'middle'"
        [class.justify-end]="sidenav?.placement === 'bottom'"
        [opened]="sidenavOpened()"
        (closed)="onCloseSidenav()"
        mode="over"
        position="end"
      >
        <app-sidepanel
          (close)="onCloseSidenav()"
        ></app-sidepanel>
      </mat-sidenav>
    </mat-sidenav-container>
  </ng-template>
</main>
